import React from "react";
import clsx from "clsx";
import styles from "./Panel.module.scss";

type IPanel = React.HTMLAttributes<HTMLElement> & {
  children: React.ReactNode;
  element?: "div" | "article" | "section" | "li";
};

export const Panel = ({
  children,
  element = "div",
  className,
  ...props
}: IPanel) => {
  return React.createElement(
    element,
    { ...props, className: clsx(styles.panel, className) },
    children,
  );
};
